// extracted by mini-css-extract-plugin
export default {"buttons_style":"Buttons_buttons_style__ByS7D"};